export default __webpack_public_path__ + "static/media/md-card-bg-AWS-C03.95500b7e.png";